import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useModalKeyTrap } from '../../hooks/useModalKeyTrap';
import './ExitModal.css';

interface ExitModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const ExitModal: React.FC<ExitModalProps> = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();
  const [focusedBtn, setFocusedBtn] = useState(0); // 0 = Yes, 1 = No

  useModalKeyTrap(useCallback(function (key, e) {
    if (key === 'ArrowLeft' || key === 'ArrowUp') {
      e.preventDefault();
      setFocusedBtn(0);
    } else if (key === 'ArrowRight' || key === 'ArrowDown') {
      e.preventDefault();
      setFocusedBtn(1);
    } else if (key === 'Enter' || key === 'Space') {
      e.preventDefault();
      if (focusedBtn === 0) onConfirm();
      else onCancel();
    } else if (key === 'Back') {
      e.preventDefault();
      onCancel();
    }
  }, [focusedBtn, onConfirm, onCancel]));

  return (
    <div className="exitmodal__overlay" onClick={onCancel}>
      <div className="exitmodal__box" onClick={(e) => e.stopPropagation()}>
        <p className="exitmodal__title">{t('app.exitConfirm')}</p>
        <div className="exitmodal__actions">
          <button
            className={`exitmodal__btn exitmodal__btn--yes${focusedBtn === 0 ? ' exitmodal__btn--focused' : ''}`}
            onClick={onConfirm}
          >
            {t('common.yes')}
          </button>
          <button
            className={`exitmodal__btn exitmodal__btn--no${focusedBtn === 1 ? ' exitmodal__btn--focused' : ''}`}
            onClick={onCancel}
          >
            {t('common.no')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExitModal;
